export const Data = {  
  webUrl: "https://tech.getyouniq.com/",
    apiUrl: "https://api.getyouniq.com/api/",
    characterLimit : 140,
  imageUrl: "https://tech.getyouniq.com/cdn-cgi/imagedelivery/"
};